import React from 'react';
import { motion } from 'framer-motion';
import { BriefcaseIcon, CheckCircleIcon } from 'lucide-react';
export function Careers() {
  const benefits = ['Competitive Pay & Bonuses', 'Full Health, Dental & Vision', '401(k) with Company Match', 'Paid Time Off & Holidays', 'Top-of-the-line Equipment', 'Ongoing Training & Certification'];
  return <section id="careers" className="py-20 bg-secondary text-white" data-id="element-82">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-83">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-84">
          <div className="w-full lg:w-1/2" data-id="element-85">
            <span className="inline-block text-primary text-base font-bold tracking-[0.2em] uppercase mb-4" data-id="element-86">
              Careers
            </span>
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-87">
              Join the Uzoma Fleet
            </h2>
            <p className="text-white/80 text-lg mb-8 leading-relaxed" data-id="element-88">
              We're always looking for dedicated, professional drivers and
              dispatchers to join our growing team. If you're passionate about
              helping people and want to work with the best equipment in the
              industry, we want to hear from you.
            </p>
            <button className="bg-primary hover:bg-red-800 text-white font-bold py-4 px-8 rounded-[10px] transition-colors shadow-lg flex items-center gap-2" data-id="element-89">
              <BriefcaseIcon className="w-5 h-5" data-id="element-90" />
              View Open Positions
            </button>
          </div>
          <div className="w-full lg:w-1/2" data-id="element-91">
            <div className="bg-white/10 rounded-[10px] p-8 border border-white/20" data-id="element-92">
              <h3 className="text-2xl font-bold mb-6" data-id="element-93">Why Drive With Us?</h3>
              <ul className="space-y-4" data-id="element-94">
                {benefits.map((benefit, idx) => <motion.li key={idx} initial={{
                opacity: 0,
                x: 20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: idx * 0.1
              }} className="flex items-center gap-3" data-id="element-95">
                    <CheckCircleIcon className="w-6 h-6 text-primary shrink-0" data-id="element-96" />
                    <span className="text-lg font-medium" data-id="element-97">{benefit}</span>
                  </motion.li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}